import { FC } from "preact/compat";
import { GridCellRingProps } from "./interfaces";

const GridCellRing: FC<GridCellRingProps> = ({
    hasData,
    projectColor,
    feecodeColor,
}) => {
    const show = hasData && Boolean(projectColor || feecodeColor);

    if (!show) {
        return null;
    }

    return (
        <div className="absolute -inset-[6px] pointer-events-none">
            <svg viewBox="0 0 100 100" className="w-full h-full">
                {projectColor && feecodeColor ? (
                    <g transform="rotate(20 50 50)">
                        <circle
                            cx="50"
                            cy="50"
                            r="45"
                            fill="none"
                            stroke={projectColor}
                            strokeWidth="10"
                            strokeDasharray="141.37 141.37"
                            transform="rotate(-90 50 50)"
                        />
                        <circle
                            cx="50"
                            cy="50"
                            r="45"
                            fill="none"
                            stroke={feecodeColor}
                            strokeWidth="10"
                            strokeDasharray="141.37 141.37"
                            strokeDashoffset="141.37"
                            transform="rotate(-90 50 50)"
                        />
                    </g>
                ) : (
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        fill="none"
                        stroke={projectColor || feecodeColor || ""}
                        strokeWidth="10"
                    />
                )}
            </svg>
        </div>
    );
};

export default GridCellRing;
